import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum MarketDataFeedBundleFormErrorStatesEnum {
    CreateMarketDataFeedBundleFailed = ErrorStateScheduleEnum.MarketDataFeedBundleFormStatesStartIndex,
    UpdateMarketDataFeedBundleFailed,
    MarketDataFeedOfBundleRemoveFailedNeedToSelectMinFeed,
    MarketDataFeedOfBundleRemoveFailedNeedToStayMinFeed,
    CreateMarketDataFeedBundleFailedNoFeed,
    GetMarketDataDetailFailed,
    GetExchangesFailed,
}
